module.exports = __webpack_public_path__ + "static/media/lost-final.a55db24d.svg";